import React from 'react';
import styled from 'styled-components';

interface Props {
  size?: number;
  spinner?: boolean;
  color?: React.CSSProperties['color'];
}

const LoadingIcon: React.FC<Props> = ({ size = 30, spinner = true, color, ...props }) => {
  return (
    <span
      style={{
        width: size,
        height: size,
        borderTopColor: color || '#1890ff',
        ...(spinner ? { animation: 'spin 1s linear infinite' } : {}),
      }}
      {...props}
    />
  );
};
export default styled(LoadingIcon)`
  display: block;
  z-index: 10;
  border-radius: 50%;
  border: 2px solid rgba(0, 0, 0, 0.1);

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;
